var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamAdd = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8 8.9L12.4 9.2C11.6 9.2 10.9 8.7 10.9 7.9L10.6 5.5H10.7L14.8 8.9Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 17.7001C15.7 18.5001 15.1 19.2001 14.4 19.2001L6.89996 20.0001H6.79996H6.59996C5.79996 20.1001 5.09996 19.5001 5.09996 18.8001L3.99996 7.6001C3.89996 6.8001 4.49996 6.1001 5.19996 6.1001L10.5 5.6001H10.6L10.8 7.9001C10.8 8.1001 10.9 8.3001 11 8.4001C11.1 8.5001 11.2 8.7001 11.3 8.8001C11.6 9.1001 12 9.2001 12.4 9.2001H12.6H12.7L14.7 9.0001L15.6 17.7001Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 8.9001L14.8999 9.0001H14.7999L12.9999 9.2001C12.8999 9.2001 12.7999 9.2001 12.7999 9.2001C12.0999 9.2001 11.5999 8.6001 11.4999 8.0001L11.2999 6.1001V6.0001V5.6001H11.3999L15.3999 8.9001Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 17.7001C15.6999 18.5001 15.0999 19.2001 14.3999 19.2001L6.89993 20.0001C6.29993 19.9001 5.69993 19.4001 5.69993 18.8001L4.59993 7.6001C4.49993 6.8001 5.09993 6.1001 5.79993 6.1001L10.5999 5.6001H10.6999H10.9999H11.0999V6.0001V6.1001L11.2999 7.9001C11.3999 8.6001 11.8999 9.1001 12.5999 9.1001C12.6999 9.1001 12.7999 9.1001 12.7999 9.1001L14.7999 9.0001L15.5999 17.7001Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.3H15.3C14.4 8.3 13.7 7.6 13.7 6.7V4L13.8 4.1L18 8.3Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 8.3V18.4C17.9999 19.3 17.2999 20 16.3999 20H7.4999C6.5999 20 5.8999 19.3 5.8999 18.4V5.6C5.8999 4.7 6.5999 4 7.4999 4H13.5999H13.6999V6.7C13.6999 7.6 14.3999 8.3 15.2999 8.3H17.9999Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.3V18.4C18 19.3 17.3 20 16.4 20H8.29995C7.39995 20 6.69995 19.3 6.69995 18.4V5.6C6.69995 4.7 7.39995 4 8.29995 4H13.6H13.7V6.7C13.7 7.6 14.4 8.3 15.3 8.3H18Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 11H9.5C9.2 11 9 10.8 9 10.5C9 10.2 9.2 10 9.5 10H15.4C15.7 10 15.9 10.2 15.9 10.5C15.9 10.8 15.6 11 15.4 11Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 14H9.5C9.2 14 9 13.8 9 13.5C9 13.2 9.2 13 9.5 13H15.4C15.7 13 15.9 13.2 15.9 13.5C15.9 13.8 15.6 14 15.4 14Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 16.6001H9.5C9.2 16.6001 9 16.4001 9 16.1001C9 15.8001 9.2 15.6001 9.5 15.6001H12.8C13.1 15.6001 13.3 15.8001 13.3 16.1001C13.3 16.4001 13.1 16.6001 12.8 16.6001Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.8001C20 18.6001 18.5 20.0001 16.8 20.0001C15.1 20.0001 13.6 18.5001 13.6 16.8001C13.6 15.1001 15.1 13.6001 16.8 13.6001C18.5 13.6001 20 15.0001 20 16.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 17.3001H15C14.7 17.3001 14.4 17.0001 14.4 16.7001C14.4 16.4001 14.7 16.1001 15 16.1001H18.4C18.7 16.1001 19 16.4001 19 16.7001C19 17.0001 18.7 17.3001 18.4 17.3001Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 18.4001V15.0001C16.2 14.7001 16.5 14.4001 16.8 14.4001C17.1 14.4001 17.4 14.7001 17.4 15.0001V18.4001C17.4 18.7001 17.1 19.0001 16.8 19.0001C16.4 18.9001 16.2 18.7001 16.2 18.4001Z",
    fill: "url(#paint9_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.6566,
    y1: 9.19997,
    x2: 12.4708,
    y2: 7.46434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.2147,
    y1: 4.49805,
    x2: 7.62596,
    y2: 15.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17.4737,
    y1: 4.7099,
    x2: 12.1583,
    y2: 9.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.5262,
    y1: 8.2294,
    x2: -0.507297,
    y2: 22.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.6908,
    y1: 2.8036,
    x2: 1.71085,
    y2: 34.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1.5887,
    y1: 10.3055,
    x2: 15.5813,
    y2: 10.5269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1.5411,
    y1: 13.3131,
    x2: 15.5337,
    y2: 13.5345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1.4994,
    y1: 15.9536,
    x2: 15.492,
    y2: 16.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 13.9268,
    y1: 17.2475,
    x2: 19.304,
    y2: 16.2113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 14.8285,
    y1: 14.1265,
    x2: 17.727,
    y2: 18.0138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamAdd.68ca2012.svg";
export { ForwardRef as ReactComponent };